import BenchlingConfig from 'BenchlingConfig';
import type {
  CanvasVersionFileStateQuery,
  CanvasVersionFileStateQueryVariables,
} from 'canvas-core/backbone/__generated/CanvasVersionFileStateQuery';
import {
  CANVAS_VERSION_FILE_STATE_QUERY,
  CanvasVersionFileStateGraphQL,
} from 'canvas-core/backbone/CanvasVersionGraphQL';
import {QueryResultType, useSkippableBenchlingQuery} from 'graphql-client/BenchlingQuery';
import {isInaccessible} from 'graphql-client/InaccessibleInfo';

export type CanvasVersionFileStateResult =
  | {type: 'skipped'}
  | {type: 'pending'}
  | {type: 'error'}
  | {type: 'success'; canvasVersion: CanvasVersionFileStateGraphQL};

export function useCanvasVersionFileState(
  canvasDefinitionId: string,
  canvasVersionId: string
): CanvasVersionFileStateResult {
  const queryResult = useSkippableBenchlingQuery<
    CanvasVersionFileStateQuery,
    CanvasVersionFileStateQueryVariables
  >(CANVAS_VERSION_FILE_STATE_QUERY, {
    skip: !BenchlingConfig.ENABLE_CANVAS_CORE,
    variables: {canvasVersionId},
  });

  if (queryResult.type === QueryResultType.SKIPPED) {
    return {type: 'skipped'};
  }

  if (queryResult.type === QueryResultType.PENDING) {
    return {type: 'pending'};
  }

  if (queryResult.type === QueryResultType.ERROR) {
    return {type: 'error'};
  }

  const {canvasVersion} = queryResult.data;
  if (isInaccessible(canvasVersion) || canvasVersion.definition.id !== canvasDefinitionId) {
    return {type: 'error'};
  }

  return {type: 'success', canvasVersion};
}
